import React from "react";
import { useSelector } from "react-redux";
import { logoForLanguage } from "../../utils/brand";
// import { Modal } from "react-bootstrap";

function MainLoader() {
  const language = useSelector(({ language }) => language.lang);
    return (
      // <div className="main-loader">
      //     <div className="lds-default">
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //         <div />
      //     </div>
      // </div>
      <div className="loader-modal">
        <img src={logoForLanguage(language)} alt="Redwan" className="rotating" />
      </div>
    );
}

export default MainLoader;
